import { render } from "./MilestoneList.vue?vue&type=template&id=de18e90e&scoped=true"
import script from "./MilestoneList.vue?vue&type=script&lang=js"
export * from "./MilestoneList.vue?vue&type=script&lang=js"

import "./MilestoneList.vue?vue&type=style&index=0&id=de18e90e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-de18e90e"

export default script